import React, { useEffect, useState } from "react";
import api, { fmtErr } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Card } from "../ui/card";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { Download, Upload, Database } from "lucide-react";
import { toast } from "sonner";

export default function SnapshotPanel() {
  const { user } = useAuth();
  const [env, setEnv] = useState(null);
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/env").then((r) => setEnv(r.data)).catch(() => {});
  useEffect(() => { if (user?.role === "super_admin") load(); }, [user]);
  if (user?.role !== "super_admin" || !env) return null;

  const download = async () => {
    setBusy(true);
    try {
      const r = await api.get("/admin/snapshot", { responseType: "blob" });
      const url = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = url;
      a.download = `capitalcontrol-snapshot-${new Date().toISOString().slice(0, 10)}.json.gz`; a.click(); URL.revokeObjectURL(url);
      toast.success("Snapshot scaricato");
    } catch (e) { toast.error(fmtErr(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  const upload = async () => {
    if (!file) return toast.error("Scegli il file snapshot");
    if (!window.confirm("Tutti i dati dell'ANTEPRIMA verranno sostituiti con quelli del file. Continuare?")) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", file);
      const r = await api.post("/admin/snapshot/import", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success(`Importati ${r.data.record} record da ${r.data.origine || "produzione"}`); setFile(null); load();
      setTimeout(() => window.location.reload(), 1200);
    } catch (e) { toast.error(fmtErr(e.response?.data?.detail)); } finally { setBusy(false); }
  };

  return (
    <Card className="p-5 space-y-3" data-testid="snapshot-panel">
      <div className="flex items-center justify-between gap-2">
        <div className="text-base font-semibold flex items-center gap-2"><Database className="w-4 h-4" /> Dati: produzione ↔ anteprima</div>
        <Badge className={env.preview ? "bg-amber-500" : "bg-emerald-600"} data-testid="env-badge">{env.preview ? "ANTEPRIMA (dati di prova)" : "PRODUZIONE"}</Badge>
      </div>
      {env.preview ? (
        <div className="space-y-2 text-sm">
          <p className="text-muted-foreground">Carica qui lo snapshot scaricato dalla produzione: l'anteprima diventa una copia identica (senza token e senza cron attivi). La produzione non viene mai toccata.</p>
          <div className="flex flex-wrap items-center gap-2">
            <input type="file" accept=".gz,.json" onChange={(e) => setFile(e.target.files[0])} className="text-sm" data-testid="snapshot-file" />
            <Button onClick={upload} disabled={busy || !file} data-testid="snapshot-import"><Upload className="w-4 h-4 mr-1" /> Importa in anteprima</Button>
          </div>
          {env.ultimo_snapshot && <p className="text-xs text-muted-foreground">Ultimo import: {new Date(env.ultimo_snapshot.importato_il).toLocaleString("it-IT")} · dati produzione del {new Date(env.ultimo_snapshot.esportato_il).toLocaleString("it-IT")} · {env.ultimo_snapshot.record} record</p>}
        </div>
      ) : (
        <div className="space-y-2 text-sm">
          <p className="text-muted-foreground">Scarica una copia di tutti i dati (senza token e segreti) da caricare nell'anteprima per provare le nuove funzioni sui numeri reali.</p>
          <Button onClick={download} disabled={busy} data-testid="snapshot-export"><Download className="w-4 h-4 mr-1" /> Scarica snapshot produzione</Button>
        </div>
      )}
    </Card>
  );
}
